"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConnectivity = getConnectivity;
const globalObject_1 = require("../../tools/globalObject");
function getConnectivity() {
    var _a;
    const navigator = globalObject_1.globalObject.navigator;
    return {
        status: navigator.onLine ? 'connected' : 'not_connected',
        interfaces: navigator.connection && navigator.connection.type ? [navigator.connection.type] : undefined,
        effective_type: (_a = navigator.connection) === null || _a === void 0 ? void 0 : _a.effectiveType,
    };
}
//# sourceMappingURL=connectivity.js.map